import React, { useEffect, useState } from 'react';

const ToastNotification: React.FC = () => {
  const [toasts, setToasts] = useState<
    Array<{ message: string; type: string }>
  >([]);

  useEffect(() => {
    const handleToast = (event: CustomEvent) => {
      setToasts((prevToasts) => [...prevToasts, event.detail]);
      setTimeout(() => {
        setToasts((prevToasts) => prevToasts.slice(1));
      }, 3000);
    };

    window.addEventListener('toast', handleToast as EventListener);

    return () => {
      window.removeEventListener('toast', handleToast as EventListener);
    };
  }, []);

  return (
    <div className="fixed right-4 bottom-4 space-y-2">
      {toasts.map((toast, index) => (
        <div
          key={index}
          className={`rounded p-4 text-white shadow-md ${
            toast.type === 'error' ? 'bg-red-500' : 'bg-gray-800'
          }`}
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
};

export default ToastNotification;
